import { InlineOption, InlineOptionsListControl } from "@/Common/Components/Inputs/InlineOptionsControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./VisitTypeSelectionPopup.module.scss";

interface IVisitTypeSelectionPopupProps {
    value: boolean | null;
    onChange: (isScheduleVisit: boolean) => void
    onClose: () => void;
}

function VisitTypeSelectionPopup(props: IVisitTypeSelectionPopupProps): JSX.Element {
    const { getText } = useTranslation();
    return (
        <Modal
            title={getText("SpecifyTheTypeOfVisitLabel")}
            draggable
            showX
            showOverlay
            onClose={() => props.onClose()}
        >
            <div className={styles.visitTypeSelectionOptionsContainer}>
                <InlineOptionsListControl
                    id="isNotScheduledAppointmentCheckedPopup"
                    items={[new InlineOption(false, "SRV"), new InlineOption(true, "RDV")]}
                    optionSpacing="100px"
                    onChange={option => props.onChange(option.Key)}
                    value={props.value}
                />
            </div>
        </Modal>
    );
}

export { VisitTypeSelectionPopup };
